import { Button } from '@components';
import { baseURL } from '@services/env-variables';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AnoMesReferencia } from '../components';

export const ExtratoAposentadoriaPensionistaAssistidoPage = () => {
  const navigate = useNavigate();
  const { matricula, token } = useSelector((state) => state.user.data);
  const [urlPDFExtrato, setUrlPDFExtrato] = useState('');

  useEffect(() => {
    setUrlPDFExtrato(
      `${baseURL}ObterExtratoAssistidosPensionistas?matricula=${matricula}&token=${token}&anomes=`
    );
  }, [matricula, token]);

  return (
    <>
      <Helmet>
        <title>Extrato de Saldo de Contas</title>
      </Helmet>
      <h1 className="page-title mb-3">
        <strong>Extrato de Saldo de Contas</strong>&nbsp;
      </h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      {urlPDFExtrato && (
        <AnoMesReferencia
          urlGetPDF={urlPDFExtrato}
          titleCard="Extrato"
          anoInicialDefault={2024}
          mesInicialDefault={12}
        />
      )}
    </>
  );
};
